// Типы соответствуют JSON, который отдаёт Go-бэкенд (internal/model, internal/store).

export type TransportKind = "modbus_tcp" | "modbus_rtu" | "mqtt" | "lora";

export interface MeterState {
  meterId: number;
  online: boolean;
  lastSeen: string;
  lastError?: string;
  errStreak: number;
}

export interface Meter {
  id: number;
  slug: string;
  name: string;
  serial: string;
  location: string;
  transport: TransportKind;
  address: string;
  unitId: number;
  regMap: string;
  intervalMs: number;
  enabled: boolean;
  baud?: number;
  dataBits?: number;
  parity?: string;
  stopBits?: number;
}

/** Счётчик вместе с состоянием связи и последними значениями. */
export interface MeterView extends Meter {
  state: MeterState;
  latest: Record<string, number>;
  latestTs: string;
}

/** Один замер: набор метрик на момент времени. */
export interface Reading {
  meterId: number;
  ts: string;
  values: Record<string, number>;
}

/** Временной ряд одной метрики. Время и значения — параллельные массивы. */
export interface Series {
  metric: string;
  unit: string;
  label: string;
  ts: number[];
  values: number[];
}

export interface HistoryResponse {
  meterId: number;
  from: string;
  to: string;
  bucket: string;
  series: Series[];
}

export interface MetricMeta {
  name: string;
  unit: string;
  label: string;
  cumulative: boolean;
  displayRank: number;
}

/** Настройки подсчёта стоимости и текущая биржевая цена. */
export interface PricingInfo {
  enabled: boolean;
  provider?: string;
  zone?: string;
  currency?: string;
  spotPerMWh?: number;
  spotPerKWh?: number;
}

/** Стоимость потреблённой энергии за период. */
export interface CostResponse {
  meterId: number;
  from: string;
  to: string;
  zone: string;
  currency: string;
  kwh: number; // потреблено за период
  amount: number; // стоимость в валюте
  covered: boolean; // весь ли период покрыт ценами
  missing: number; // кВт·ч без тарифа
  spotPerMWh?: number;
  spotPerKWh?: number;
}

/** Стоимость за один календарный период (сутки, месяц). */
export interface CostPeriod {
  from: string;
  kwh: number;
  amount: number;
  covered: boolean;
  missing: number;
}

/** Сводка «сколько потрачено сегодня и за месяц». */
export interface CostSummaryResponse {
  meterId: number;
  to: string;
  zone: string;
  currency: string;
  spotPerMWh?: number;
  spotPerKWh?: number;
  day: CostPeriod;
  month: CostPeriod;
}

export interface Health {
  status: string;
  uptime: string;
  meters: number;
  readings: number;
  online: number;
  wsClients: number;
  wsDropped: number;
}

/** Сообщение WebSocket. Первым приходит snapshot, дальше инкременты. */
export interface WSMessage {
  type: "snapshot" | "reading" | "state";
  meters?: MeterView[];
  reading?: Reading;
  state?: MeterState;
  ts: string;
}

/** Человекочитаемые названия транспортов. */
export const transportLabels: Record<TransportKind, string> = {
  modbus_tcp: "Modbus TCP",
  modbus_rtu: "Modbus RTU",
  mqtt: "MQTT",
  lora: "LoRa",
};
